import type { Currency } from '@zapier/currency/src/types';
import { defaultCurrency } from '@zapier/currency/src/hooks/useCurrencies';
import { formatPrice } from './formatPrice';
import { formatPriceWithCurrencySymbol } from './formatPriceWithCurrencySymbol';
import { PriceFormattingOptions } from './types';

/**
 * Applies currency multiplier and formats price.
 */
export const formatPriceToBeInCurrency = (
  price: number,
  currency: Currency = defaultCurrency,
  includeSymbol: boolean = true,
  formattingOptions?: Partial<PriceFormattingOptions>
) => {
  const adjusted = price * currency.multiplier;

  return includeSymbol
    ? formatPriceWithCurrencySymbol(
        adjusted,
        formattingOptions,
        currency.symbol
      )
    : formatPrice(adjusted, formattingOptions);
};
